import { render, staticRenderFns } from "./AdminOrganizationSwitcher.vue?vue&type=template&id=755feb78&scoped=true&"
import script from "./AdminOrganizationSwitcher.vue?vue&type=script&lang=js&"
export * from "./AdminOrganizationSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrganizationSwitcher.vue?vue&type=style&index=0&id=755feb78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755feb78",
  null
  
)

export default component.exports